import {useQuery} from "@apollo/client";

import {useCurrentUserContext} from "@/components/context/hooks";
import {useTable} from "@/lib/hooks/useTable.ts";
import {GQL_STATUS_PAGES_NAMES_QUERY, GQL_STATUS_PAGES_QUERY_WITH_INCIDENT_COUNTS} from "@/lib/queries/statuspages.ts";
import {StatusPageList} from "@/lib/types/statuspages.ts";
import {StatusPagesControlBar} from "@/pages/statuspages/list/components/StatusPagesControlBar.tsx";

import {StatusPagesTable} from "../components/StatusPagesTable.tsx";

export const STATUS_PAGES_STORAGE_KEYS = {
  DEFAULT: "status_pages_list_filters",
} as const;

export const StatusPagesList = () => {
  const {user, brand} = useCurrentUserContext();
  const {
    search,
    searchDebounced,
    searchChanged,
    pagination,
    setPagination,
    sorting,
    setSorting,
    sortingString,
    filterSets,
    setFilterSets,
  } = useTable({sessionStorageKey: STATUS_PAGES_STORAGE_KEYS.DEFAULT});

  const {data, previousData, loading} = useQuery<StatusPageList>(GQL_STATUS_PAGES_QUERY_WITH_INCIDENT_COUNTS, {
    variables: {
      ...pagination,
      orderBy: sortingString,
      filters: filterSets,
      search: searchDebounced,
    },
  });

  const items = data?.statusPages.items || previousData?.statusPages.items;

  const {data: dataForFilter} = useQuery<StatusPageList>(GQL_STATUS_PAGES_NAMES_QUERY, {
    variables: {
      offset: 0,
      limit: 10000,
      filters: filterSets,
      search: searchDebounced,
    },
  });
  return (
    <>
      <StatusPagesControlBar
        search={search}
        setSearch={searchChanged}
        filterSets={filterSets}
        onFilterSetChange={setFilterSets}
        items={dataForFilter?.statusPages.items || []}
      />
      <StatusPagesTable
        brand={brand}
        items={items || []}
        hasAdminAccess={user?.has_admin_access}
        hasWriteAccess={user?.has_write_access}
        sortColumn={sorting.column}
        sortDirection={sorting.direction}
        onSortingChange={setSorting}
        isFilteringApplied={Object.keys(filterSets).length > 0 || searchDebounced.length > 0}
        loading={loading}
        pagination={pagination}
        updatePagination={setPagination}
        totalRows={dataForFilter?.statusPages.total || 0}
      />
    </>
  );
};
